module.exports = {
  purge: {
    content: ['./src/**/*.{js,jsx,ts,tsx}'],
    options: {
      safelist: [],
    },
  },
  darkMode: false, // or 'media' or 'class'
  theme: {
    container: {
      padding: {
        DEFAULT: '1rem',
        sm: '2rem',
        lg: '4rem',
        xl: '10rem',
        '2xl': '10rem',
      },
      center: true,
    },
    listStyleType: {
      none: 'none',
      disc: 'disc',
      decimal: 'decimal',
      square: 'square',
    },
    letterSpacing: {
      tighter: '-.05em',
      tight: '-.025em',
      normal: '0',
      wide: '.025em',
      wider: '.05em',
      widest: '.1em',
      extreme: '.175em',
    },
    extend: {
      zIndex: {
        '-10': '-10',
      },
      fontSize: {
        '6xl': '4rem',
      },
      padding: {
        4.5: '1.125rem',
        7.5: '1.875rem',
      },
      lineHeight: {
        '18px': '18px',
        '20px': '20px',
        '24px': '24px',
        '30px': '30px',
        '64px': '64px',
        '72px': '72px',
      },
      fontFamily: {
        palanquin: [
          'Palanquin',
          'ui-sans-serif',
          'system-ui',
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          '"Noto Sans"',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"',
        ],
        palanquinDark: [
          'Palanquin Dark',
          'ui-sans-serif',
          'system-ui',
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          '"Noto Sans"',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"',
        ],
      },
      colors: {
        black: '#101216',
        blackTransparent80: 'rgba(16, 18, 22, 0.8)',
        secondaryGray500: '#D9DBE9',
        secondaryGray600: '#A0A3BD',
        secondaryGray700: '#6E7191',
        secondaryBlack: '#101216',
        ultraDarkGray: '#14142B',
        megaDarkGray: '#4E4B66',
        mediumDarkGray: '#6E7191',
        smallLightGray: '#D9DBE9',
        secondaryGray: '#A0A3BD',
        mediumLightGray: '#EFF0F6',
        megaLightGray: '#F7F7FC',
        lightRed: '#F3686D',
        red: '#F04248',
        darkRed: '#ED1D23',
        lightBlue: '#B7A9EF',
        blue: '#6F54DE',
        darkBlue: '#5331D8',
        lightGreen: '#18A03E',
        green: '#0D5722',
        darkGreen: '#083515',
        lightSeaweed: '#03C4DD',
        seaweed: '#028090',
        darkSeaweed: '#025964',
        lightYellow: '#FFD35C',
        yellow: '#FFBB00',
        darkYellow: '#CC9600',
        lightCorn: '#FFF9C2',
        corn: '#FFF275',
        darkCorn: '#FFE91F',
        white: '#FFFFFF',
      },
    },
  },
  variants: {
    extend: {},
  },
  plugins: ['gatsby-plugin-postcss'],
}
